import { cn } from '@/lib/utils'

interface KinkUpLogoProps {
  /** Width & height in px */
  size?: number
  className?: string
  /** Enable stroke-draw entrance animation */
  animated?: boolean
}

/**
 * KinkUp brand mark — stylised K with upward arrow from vertical stroke.
 * Four discrete paths allow independent CSS / JS animation of each segment.
 */
export function KinkUpLogo({ size = 64, className, animated }: KinkUpLogoProps) {
  return (
    <svg
      viewBox="0 0 64 64"
      width={size}
      height={size}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('shrink-0', className)}
      aria-label="KinkUp logo"
    >
      <defs>
        <linearGradient id="ku-grad" x1="16" y1="56" x2="16" y2="6" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="hsl(var(--primary))" />
          <stop offset="100%" stopColor="hsl(var(--primary) / 0.6)" />
        </linearGradient>
      </defs>

      {/* Shaft — vertical line of K, extended upward into arrow */}
      <path
        d="M 16 56 L 16 16"
        stroke="url(#ku-grad)"
        strokeWidth="5.5"
        strokeLinecap="round"
        className={animated ? 'kinkup-draw' : undefined}
        style={animated ? { '--path-len': '40', '--draw-delay': '0s' } as React.CSSProperties : undefined}
      />

      {/* Arrowhead — crowns the shaft */}
      <path
        d="M 7 24 L 16 8 L 25 24"
        stroke="url(#ku-grad)"
        strokeWidth="5.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={animated ? 'kinkup-draw' : undefined}
        style={animated ? { '--path-len': '36', '--draw-delay': '0.25s' } as React.CSSProperties : undefined}
      />

      {/* Upper arm of K */}
      <path
        d="M 16 38 L 48 16"
        stroke="url(#ku-grad)"
        strokeWidth="5.5"
        strokeLinecap="round"
        className={animated ? 'kinkup-draw' : undefined}
        style={animated ? { '--path-len': '38', '--draw-delay': '0.4s' } as React.CSSProperties : undefined}
      />

      {/* Lower arm of K */}
      <path
        d="M 16 38 L 48 56"
        stroke="url(#ku-grad)"
        strokeWidth="5.5"
        strokeLinecap="round"
        className={animated ? 'kinkup-draw' : undefined}
        style={animated ? { '--path-len': '37', '--draw-delay': '0.45s' } as React.CSSProperties : undefined}
      />
    </svg>
  )
}
